import { NavLink, useHistory } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../components/Breadcrumb';
import { ContactsSelfImport } from '../../components/contacts/ContactsSelfImport';
import { MultiContainerHeader } from '../../components/MultiContainerHeader';

export function PolicyContactsImportFromCSVPage() {
	const history = useHistory();
	const onProcessingRequestClose = () => {
		history.push(`/dataBoards/policies`);
	};
	return (
		<>
			<MultiContainerHeader
				appBarHeader={
					<Breadcrumb>
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<NavLink to='/dataBoards'>Data Boards</NavLink>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<NavLink to='/dataBoards/policies'>Policies</NavLink>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
							<BreadcrumbPage>CSV Import</BreadcrumbPage>
						</BreadcrumbList>
					</Breadcrumb>
				}
			/>

			<ContactsSelfImport onRequestClose={onProcessingRequestClose} completedBtnText='Back to policies' />
		</>
	);
}
